import { render, staticRenderFns } from "./AdverStatistics.vue?vue&type=template&id=239feca6&scoped=true"
import script from "./AdverStatistics.vue?vue&type=script&lang=js"
export * from "./AdverStatistics.vue?vue&type=script&lang=js"
import style0 from "./AdverStatistics.vue?vue&type=style&index=0&id=239feca6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "239feca6",
  null
  
)

export default component.exports